import { useRecommendedForYouArticlesQuery } from '../../../generated/frontend'
import type { Layout, Model } from '../Recommendations'
import { getModelsData, Recommendations } from '../Recommendations'

type ModelRecommendationsProps = {
  modelKey: Model
  whichId: string
  layout: Layout
  position?: string
}

export const ModelRecommendations = ({
  modelKey,
  whichId,
  layout,
  position,
}: ModelRecommendationsProps) => {
  const { data, loading } = useRecommendedForYouArticlesQuery()

  if (loading) {
    return null
  }

  const allModels = getModelsData(data?.recommendations?.models ?? [])
  const model = allModels[modelKey]

  if (model) {
    return <Recommendations model={model} whichId={whichId} layout={layout} position={position} />
  }

  return null
}
